import React from 'react';
import PropTypes from 'prop-types';

const Avatar = props => {
  const size = props.size || 35;
  const sizeInPx = `${size}px`;

  return (
    <div className="m-profile-header-avatar">
      <img
        src="img/icons/user.svg"
        style={{ width: sizeInPx, height: sizeInPx, minWidth: sizeInPx, minHeight: sizeInPx }}
      />
    </div>
  );
};

Avatar.propTypes = {
  size: PropTypes.number,
};

export default Avatar;
